interface UserFilterProps {
  users: string[];
  value: string;
  onChange: (value: string) => void;
}

// Per-user scope selector for Overview / Routing / Savings. Mirrors the
// TimeRangeSelector: empty value ("") means "All users" — the unfiltered,
// tenant-wide view that is the default behavior. Only rendered by Layout when
// the tenant has 2+ end-users.
export function UserFilter({ users, value, onChange }: UserFilterProps) {
  return (
    <label className="flex items-center gap-1.5 text-xs text-fg-muted">
      <span className="sr-only">Filter by user</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Filter by user"
        className="rounded-md border border-line bg-canvas px-2 py-1 text-xs text-fg focus:border-electric-blue focus:outline-none focus:ring-1 focus:ring-electric-blue/50"
      >
        <option value="">All users</option>
        {users.map((u) => (
          <option key={u} value={u}>
            {u}
          </option>
        ))}
      </select>
    </label>
  );
}
